import { normalizeSocialUrl } from "@/lib/urlUtils";

const platformUrl = (value, platformBase, prefix = "") => {
  const normalized = normalizeSocialUrl(value);
  if (/^https?:\/\//i.test(normalized)) return normalized;
  const handle = normalized.replace(/^@/, "").replace(/^(Instagram|Facebook|TikTok):\s*@?/i, "");
  return `${platformBase}${prefix}${handle}`;
};

export const SocialMediaIcons = ({ instagram, facebook, tiktok, className = "" }) => {
  if (!instagram && !facebook && !tiktok) return null;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="social-media-icons">
      {instagram && (
        <a
          href={platformUrl(instagram, "https://instagram.com/")}
          target="_blank"
          rel="noopener noreferrer"
          className="w-9 h-9 rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] flex items-center justify-center hover:opacity-80 transition-opacity"
          data-testid="social-instagram-link"
          title="Instagram"
        >
          <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
        </a>
      )}
      {facebook && (
        <a
          href={platformUrl(facebook, "https://facebook.com/")}
          target="_blank"
          rel="noopener noreferrer"
          className="w-9 h-9 rounded-full bg-[#1877F2] flex items-center justify-center hover:opacity-80 transition-opacity"
          data-testid="social-facebook-link"
          title="Facebook"
        >
          <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
        </a>
      )}
      {tiktok && (
        <a
          href={platformUrl(tiktok, "https://tiktok.com/", "@")}
          target="_blank"
          rel="noopener noreferrer"
          className="w-9 h-9 rounded-full bg-[#1a1a1a] flex items-center justify-center hover:opacity-80 transition-opacity"
          data-testid="social-tiktok-link"
          title="TikTok"
        >
          <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64c.3 0 .59.05.86.13V9.4a6.35 6.35 0 00-.86-.06 6.33 6.33 0 00-6.33 6.33 6.33 6.33 0 0010.82 4.48 6.33 6.33 0 001.86-4.48V8.73a8.28 8.28 0 004.84 1.55V6.83c-.37 0-.73-.05-1.08-.14z"/></svg>
        </a>
      )}
    </div>
  );
};
